import { IChannel } from './ichannel';
import { IAnnotation } from '@se/models';
import { IFilter } from './ifilter';
import { isArray } from 'lodash-es';

export interface IWaveform {
    channels: Array<IChannel>;
    annotations: Array<IAnnotation>;
    filters: Array<IFilter>;
}

export function isWaveform(object: any): object is IWaveform {
    let isWaveform: boolean = true;

    isWaveform = isWaveform && 'channels' in object && isArray(object['channels']);
    isWaveform = isWaveform && 'annotations' in object && isArray(object['annotations']);
    isWaveform = isWaveform && 'filters' in object && isArray(object['filters']);

    return isWaveform;
}
